<template>
  <article class="teacher">
    <div class="avatar">
      <BaseImage
        v-if="teacher?.avatar"
        class="fill-space"
        :image="teacher.avatar"
      />
      <UserIcon v-else class="fill-space" />
    </div>
    <div class="info">
      <p class="position t-p-s-130">{{ t('timetable.teacher') }}:</p>
      <p class="name t-p-m-130" v-html="nbsp(teacher.full_name)" />
    </div>
  </article>
</template>

<script setup lang="ts">
import UserIcon from '@/assets/icons/user.svg?component'
import type { Teacher } from '@/service/__generated-api'

const { t } = useI18n()

defineProps<{ teacher: Teacher }>()
</script>

<style scoped lang="scss">
.teacher {
  display: flex;
  gap: rem(18px);
  align-items: center;
}

.avatar {
  @include size(68px);
  position: relative;
  overflow: hidden;
  border-radius: 50%;
}

.position {
  color: $layout-text-03;
}
</style>
